<template>
    <div class="page">
        <div>
            <div class="Profile-edit-head">
                {{$t('editProfile.EditProfile')}}
            </div>
            <div class="Profile-edit-body">
                <div class="Profile-edit-content">
                    <div class="Profile-edit-content-ziliao">
                        <p>{{$t('editProfile.LocationID')}} </p>
                        <input class="input-background-hui" :placeholder="siteInfo ? siteInfo.siteSerialNumber : null"
                               disabled="disabled">
                    </div>
                    <div class="Profile-edit-content-ziliao">
                        <p>{{$t('editProfile.LocationNameEnglish')}}</p>
                        <input class="input-background-bai"  v-model="siteInfo.siteNameEn">
                    </div>
                    <div class="Profile-edit-content-ziliao">
                        <p>{{$t('editProfile.LocationNameChinese')}}</p>
                        <input class="input-background-bai"  v-model="siteInfo.siteName">
                    </div>
                    <div class="Profile-edit-content-ziliao">
                        <p>{{$t('editProfile.AddressEnglish')}}</p>
                        <input class="input-background-bai"  v-model="siteInfo.streetAddressEn">
                    </div>
                    <div class="Profile-edit-content-ziliao">
                        <p>{{$t('editProfile.AddressChinese')}}</p>
                        <input class="input-background-bai"  v-model="siteInfo.streetAddress">
                    </div>
                    <div class="Profile-edit-content-ziliao">
                        <p>{{$t('editProfile.ShopContact')}}</p>
                        <input class="input-background-bai"  v-model="siteInfo.contact">
                    </div>
                    <div class="Profile-edit-content-ziliao">
                        <p>{{$t('editProfile.Username')}}</p>
                        <input class="input-background-hui" :placeholder="siteInfo ? siteInfo.username : null"
                               disabled="disabled">
                    </div>
                    <div class="Profile-edit-content-ziliao">
                        <p>{{$t('editProfile.RegisteredPhoneNnumber')}}</p>
                        <input class="input-background-hui" :placeholder="siteInfo ? siteInfo.registedMobile : null"
                               disabled="disabled">
                    </div>
                    <div class="Profile-edit-content-check">
                        <div class="Profile-edit-content-check-Businesshours">
                            <p>{{$t('editProfile.BusinessHours')}}</p>

                            <div v-for="(day, weekName) in weekDay"
                                 class="Profile-edit-content-check-Businesshours-dev">
                                <div class="div-width">
                                    <input :checked="day.show" :name="weekName" type="checkbox" class="week"
                                           @click="listenWeek($event,weekName)">&nbsp;{{$t(weekName)}}
                                    <div v-if="!day.show" class="rest">{{$t('editProfile.Rest')}}</div>
                                </div>

                                <div v-if="day.show" class="week-day-box Profile-edit-content-check-Businesshours-dev">
                                    <div v-if="time.show" class="Profile-edit-time"
                                         v-for="(time,index) in day.business">
                                        <div v-if="time.show">
                                            <div class="Profile-edit-open-width">
                                                <button class="open-input" type="button" id="dropdownMenu3"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="true">
                                                    <font :style="{color:time.open === 'Open' ? '#ACACAC' : '#111'}">
                                                        {{time.open === 'Open' ? $t('editProfile.Open') : time.open}}
                                                    </font>
                                                    <span class="caret caret-weizhi"></span>
                                                </button>
                                                <ul class="dropdown-menu Profile-edit-list Profile-edit-list-open"
                                                    aria-labelledby="dropdownMenu3">
                                                    <li @click="select_open($event,weekName,index)"
                                                        v-for="item in list">
                                                        <a>{{item}}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="henggang">-</div>
                                            <div class="Profile-edit-open-width">
                                                <button class="close-input" type="button" id="dropdownMenu4"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="true">
                                                    <font :style="{color:time.close === 'Close' ? '#ACACAC' : '#111'}">
                                                        {{time.close === 'Close' ? $t('editProfile.Close') : time.close}}
                                                    </font>
                                                    <span class="caret caret-weizhi"></span>
                                                </button>
                                                <ul class="dropdown-menu Profile-edit-list Profile-edit-list-close"
                                                    aria-labelledby="dropdownMenu4">
                                                    <li @click="select_close($event,weekName,index)"
                                                        v-for="item in list">
                                                        <a>{{item}}</a></li>
                                                </ul>
                                            </div>
                                            <div v-if="time.del" class="iconfont icon-chacha iconfont-hui"
                                                 @click="Cut_more_hours($event,weekName,index)"></div>
                                        </div>
                                    </div>
                                    <div v-if="day.addHours" class="Add_more_hours"
                                         @click="Add_more_hours($event,weekName)">
                                        {{$t('editProfile.AddMoreHours')}}
                                    </div>
                                    <div class="open-24-hours">
                                        <input :checked="day.allTimeShow" type="checkbox" class="fullDay"
                                               @click="openFullDay($event,weekName)" style="marginTop:0px"/><div>&nbsp;&nbsp;{{$t('editProfile.OpenHours')}}</div>
                                    </div>
                                </div>
                            </div>
                            <div id="special_hours">
                                <div class="Exceptions width-100">{{$t('editProfile.ExceptionsOrHolidays')}}</div>
                                <div class="special-list-box">
                                    <p class="special-list-item" v-for="(item,index) in specialList" :key="index">{{timestampToString(item)}}</p>
                                </div>
                                <div class="Profile-edit-content-check-Businesshours-dev">
                                    <div v-for="item in addSpecialHours" class="Profile-edit-add-specialhours">
                                        <p class="specialList">
                                            <span>{{item.name}}:</span>
                                            <span>Rest</span>
                                        </p>
                                    </div>
                                    <div>
                                        <button class="special_hours" @click="showSpecial">
                                            {{$t('editProfile.AddSpecialHours')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="Profile-home Profile-edit-back" @click="back()">
                {{$t('common.Back')}}
            </div>
            <div class="Profile-home Profile-edit-save" @click="save()">
                {{$t('common.Save')}}
            </div>
            <bottom></bottom>
        </div>
        <div class="curtain" v-if="showCurtain"></div>
        <div class="add-special" v-if="showCurtain">
            <ul class="dropdown-menu-self Profile-edit-list Profile-edit-list-specialhours">
                <li class="Select_special_days">{{$t('editProfile.SelectSpecialDays')}}</li>
                <li class="specialhours" v-for="(item,index) in specialhours['data']">
                    <a>{{item.week}},&nbsp;{{item.date}}
                        <input type="checkbox" :checked="item.bool" :value="specialhours['time'][index]" v-model="checkSpecials">
                    </a>
                </li>
                <li class="special-action">
                    <p @click="saveSpecial" class="Profile-edit-list-specialhours-ok">{{$t('editProfile.OK')}}</p>
                    <p @click="cancelSpecial" class="Profile-edit-list-specialhours-cancel">{{$t('editProfile.Cancel')}}</p>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import bottom from './Bottom.vue'

export default {
  name: 'Editprofile',
  components: {bottom},
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background:rgba(248,248,248,1);'
  },
  data () {
    return {
      list: [
        '00 : 00', '00 : 30',
        '01 : 00', '01 : 30',
        '02 : 00', '02 : 30',
        '03 : 00', '03 : 30',
        '04 : 00', '04 : 30',
        '05 : 00', '05 : 30',
        '06 : 00', '06 : 30',
        '07 : 00', '07 : 30',
        '08 : 00', '08 : 30',
        '09 : 00', '09 : 30',
        '10 : 00', '10 : 30',
        '11 : 00', '11 : 30',
        '12 : 00', '12 : 30',
        '13 : 00', '13 : 30',
        '14 : 00', '14 : 30',
        '15 : 00', '15 : 30',
        '16 : 00', '16 : 30',
        '17 : 00', '17 : 30',
        '18 : 00', '18 : 30',
        '19 : 00', '19 : 30',
        '20 : 00', '20 : 30',
        '21 : 00', '21 : 30',
        '22 : 00', '22 : 30',
        '23 : 00', '23 : 30'
      ],
      specialhours: null,
      checkSpecials: [],
      specialList: [],
      open: 'Open',
      close: 'Close',
      activeClass: 1,
      activeClass2: 'k',
      activeClass3: 0,
      addSpecialHours: [],
      siteInfo: {'siteName': '', 'siteNameEn': '', 'contact': ''},
      timeList: [],
      weekDay: {
        'Monday': {
          'ALL_TIME': false,
          'business': [{show: true, del: false, open: 'Open', close: 'Close'}, {
            show: false,
            del: true,
            open: 'Open',
            close: 'Close'
          }],
          'addHours': true,
          'show': false,
          'allTimeShow': false
        },
        'Tuesday': {
          'ALL_TIME': false,
          'business': [{show: true, del: false, open: 'Open', close: 'Close'}, {
            show: false,
            del: true,
            open: 'Open',
            close: 'Close'
          }],
          'addHours': true,
          'show': false,
          'allTimeShow': false
        },
        'Wednesday': {
          'ALL_TIME': false,
          'business': [{show: true, del: false, open: 'Open', close: 'Close'}, {
            show: false,
            del: true,
            open: 'Open',
            close: 'Close'
          }],
          'addHours': true,
          'show': false,
          'allTimeShow': false
        },
        'Thursday': {
          'ALL_TIME': false,
          'business': [{show: true, del: false, open: 'Open', close: 'Close'}, {
            show: false,
            del: true,
            open: 'Open',
            close: 'Close'
          }],
          'addHours': true,
          'show': false,
          'allTimeShow': false
        },
        'Friday': {
          'ALL_TIME': false,
          'business': [{show: true, del: false, open: 'Open', close: 'Close'}, {
            show: false,
            del: true,
            open: 'Open',
            close: 'Close'
          }],
          'addHours': true,
          'show': false,
          'allTimeShow': false
        },
        'Saturday': {
          'ALL_TIME': false,
          'business': [{show: true, del: false, open: 'Open', close: 'Close'}, {
            show: false,
            del: true,
            open: 'Open',
            close: 'Close'
          }],
          'addHours': true,
          'show': false,
          'allTimeShow': false
        },
        'Sunday': {
          'ALL_TIME': false,
          'business': [{show: true, del: false, open: 'Open', close: 'Close'}, {
            show: false,
            del: true,
            open: 'Open',
            close: 'Close'
          }],
          'addHours': true,
          'show': false,
          'allTimeShow': false
        }
      },
      serviceTimeList: [],
      showCurtain: false
    }
  },
  created () {
    this.getSpecial()
    let siteId = this.$route.query.siteId
    if (siteId) {
      const vue = this
      this.axios({
        method: 'get',
        url: this.api.siteDetail + siteId
      }).then(function (response) {
        vue.siteInfo = response.data
        vue.timeList = response.data.serviceTimeList
        vue.initTime()
      }).catch(function (error) {
        console.log(error.data)
      })
    } else {
      alert('siteId not found')
      this.$router.back()
    }
  },
  methods: {
    initTime () {
      let timeList = this.timeList
      let i
      for (i = 0; i < timeList.length; i++) {
        let weekName = timeList[i].weekDay
        if (weekName === 'Special') {
          // 填充特殊日
          for (let j = 0; j < timeList[i].siteServiceTimes.length; j++) {
            let s_time = timeList[i].siteServiceTimes[j].openTime
            s_time = Number(s_time)
            this.specialList.push(s_time)
          }
        } else {
          // 开启指定日期
          this.weekDay[weekName].show = true
          let j
          for (j = 0; j < timeList[i].siteServiceTimes.length; j++) {
            // 日期进行填充
            let serviceTimeType = timeList[i].siteServiceTimes[j].serviceTimeType
            if (serviceTimeType === 'ALL_TIME') {
              this.weekDay[weekName].allTimeShow = true
              this.weekDay[weekName].ALL_TIME = true
              this.weekDay[weekName].business[0].show = false
              this.weekDay[weekName].business[1].show = false
              break
            }
            if (serviceTimeType === 'NORMAL') {
              this.weekDay[weekName].business[j].open = timeList[i].siteServiceTimes[j].openTime
              this.weekDay[weekName].business[j].close = timeList[i].siteServiceTimes[j].closeTime
            }
          }
        }
      }
    },
    save () {
      // 保存修改自提点资料
      const vue = this
      // 获取需要修改的数据
      let weekDay = this.weekDay
      const postData = []
      let weekArr = {Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6, Sunday: 7}
      $.each(weekDay, function (index, value) {
        if (weekDay[index].ALL_TIME === true) {
          let oneDay = {'serviceTimeType': 'ALL_TIME', 'weekDay': index, 'day': 1}
          postData.push(oneDay)
        } else if (weekDay[index].show) {
          let days = weekArr[index], time_save = false, time2_save = false
          let time = weekDay[index].business[0]
          let time2 = weekDay[index].business[1]
          if (time.show && time.open !== 'Open' && time.close !== 'Close') {
            time_save = true
          }
          if (time2.show && time2.open !== 'Open' && time2.close !== 'Close') {
            time2_save = true
          }
          if (time_save) {
            let oneDay = {
              'serviceTimeType': 'NORMAL',
              'weekDay': index,
              'openTime': time.open,
              'closeTime': time.close,
              'day': days
            }
            postData.push(oneDay)
          }
          if (time2_save) {
            let oneDay = {
              'serviceTimeType': 'NORMAL',
              'weekDay': index,
              'openTime': time2.open,
              'closeTime': time2.close,
              'day': days
            }
            postData.push(oneDay)
          }
        }
      })
      // 获取特殊休息日数据
      for (let i = 0; i < this.checkSpecials.length; i++) {
        let tmpArr = {'serviceTimeType': 'SPECIAL', 'openTime': this.checkSpecials[i]}
        postData.push(tmpArr)
      }
      this.axios({
        method: 'post',
        url: this.api.updateProfile,
        data: {
          siteId: vue.siteInfo.siteId,
          siteName: vue.siteInfo.siteName,
          siteNameEn: vue.siteInfo.siteNameEn,
          serviceTimeList: postData
        }
      }).then(function (response) {
        localStorage.setItem('locationName', vue.siteInfo.siteName)
        localStorage.setItem('locationNameEn', vue.siteInfo.siteNameEn)
        alert('Saved successfully')
        vue.$router.push('/profile')
      }).catch(function (error) {
        console.log(error.data)
      })
    },
    back () {
      this.$router.go(-1)
    },
    // 添加时间段
    Add_more_hours (obj, weekName) {
      this.weekDay[weekName].business[0].show = true
      this.weekDay[weekName].business[1].show = true
      this.weekDay[weekName].business[0].del = true
      this.weekDay[weekName].business[1].del = true
      this.weekDay[weekName].addHours = false
    },
    // 删除时间段
    Cut_more_hours (obj, weekName, index) {
      // 动态改变删除
      this.weekDay[weekName].business[index].show = false
      this.weekDay[weekName].business[0].del = false
      this.weekDay[weekName].business[1].del = false
      this.weekDay[weekName].addHours = true
    },
    // 监听选择 星期选择框
    listenWeek (e, weekName) {
      this.weekDay[weekName].show = !this.weekDay[weekName].show
      this.weekDay[weekName].ALL_TIME = false
    },
    // 开启全日开放
    openFullDay (e, weekName) {
      this.weekDay[weekName].allTimeShow = !this.weekDay[weekName].allTimeShow
      this.weekDay[weekName].ALL_TIME = !this.weekDay[weekName].ALL_TIME
      // 全日开放后，隐藏时间段
      if (this.weekDay[weekName].allTimeShow === true) {
        this.weekDay[weekName].business[0].show = false
        this.weekDay[weekName].business[1].show = false
        this.weekDay[weekName].addHours = false
      } else {
        this.weekDay[weekName].business[0].show = true
        this.weekDay[weekName].business[1].show = true
        this.weekDay[weekName].business[0].del = true
        this.weekDay[weekName].business[1].del = true
      }
    },
    // 选择开门时间
    select_open (e, weekName, index) {
      let time = e.srcElement.text
      time = time.replace(/\s*/g, '')
      this.weekDay[weekName].business[index].open = time
    },
    // 选择闭门时间
    select_close (e, weekName, index) {
      let time = e.srcElement.text
      time = time.replace(/\s*/g, '')
      this.weekDay[weekName].business[index].close = time
    },
    saveSpecial () {
      this.specialList = this.checkSpecials
      this.showCurtain = false
    },
    cancelSpecial () {
      this.showCurtain = false
    },
    getSpecial () {
      let monthArr, weekArr
      monthArr = this.$t('common.monthArr')
      weekArr = this.$t('common.weekArr')
      let listArr = new Array()
      listArr['data'] = []
      listArr['time'] = []
      // 获取当前日期的时间戳
      let time_base = new Date(new Date().setHours(0, 0, 0, 0))
      let timestamp_base = time_base.getTime()
      for (let i = 0; i < 7; i++) {
        let c_time = timestamp_base + i * 86400000
        // 获取当前日期的时间戳
        let time = new Date(c_time)
        // 获取月份
        let m = monthArr[time.getMonth()] + this.$t('common.space')
        // 获取当月的第几日
        let day = time.getDate() + this.$t('common.dayFormat')
        // 获取一周中的第几日
        let week_day = weekArr[time.getDay()]
        listArr['data'][i] = {week: week_day, date: m + day, bool: false}
        listArr['time'][i] = c_time
      }
      this.specialhours = listArr
    },
    timestampToString (c_time = 0) {
      let monthArr, weekArr
      monthArr = this.$t('common.monthArr')
      weekArr = this.$t('common.weekArr')
      let time = new Date(c_time)
      // 获取月份
      let m = monthArr[time.getMonth()]
      // 获取当月的第几日
      let day = time.getDate()
      // 获取一周中的第几日
      let week = weekArr[time.getDay()]
      return week + ', ' + m + ' ' + day + this.$t('common.dayFormat')
    },
    showSpecial () {
      this.showCurtain = true
    }
  }
}
</script>
<style src="../assets/css/bootstrap.css" scoped>
</style>
<style scoped>
    .open-24-hours {
        /*margin-bottom: 0.1rem;*/
        margin-top: 0.15rem;
        margin-left: 10.57% !important;
        width: 100%;
        text-align: left;
        margin-bottom: 0.045rem;
        display: flex;
        justify-items: center;
    }

    .div-width {
        width: 100%;
        text-align: left;
        margin-bottom: 0.045rem;
    }

    .open-input, .close-input {
        padding-left: 0.06rem;
    }

    input[type="checkbox"] {
        width: 0.15rem;
        height: 0.15rem;
        display: inline-block;
        text-align: center;
        vertical-align: sub;
        line-height: 18px;
        position: relative;
        background: rgba(255, 255, 255, 1);
        border: none;
    }

    .week-day-box {
        margin-top: 0 !important;
    }

    input[type="checkbox"]::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        background: #fff;
        width: 100%;
        height: 100%;
        border: 0.01rem solid #d9d9d9;
        border-radius: 0.03rem;
    }

    input[type="checkbox"]:checked::before {
        content: "\2713";
        /* background: rgba(31, 141, 197, 1); */
        background: var(--primary-color);
        position: absolute;
        top: 0;
        left: 0;
        line-height: 0.15rem;
        width: 100%;
        /* border: 0.01rem solid rgba(31, 141, 197, 1); */
        border: var(--primary-color);
        /*color:#e50232;*/
        color: #fff;
        font-size: 0.12rem;
        font-weight: bold;
    }

    .friday > a {
        font-weight: 600 !important;
    }

    #special_hours {
        margin-top: 0.17rem;
    }

    .Exceptions {
        color: #aaa;
        font-weight: 400;
        font-size: 0.15rem;
        width: 100%;
        text-align: left;
        margin-bottom: 0.045rem;
    }

    .Profile-edit-add-specialhours {
        color: #aaa !important;
    }

    .specialList span {
        color: #aaa !important;
        font-weight: 400 !important;
        float: none !important;
        text-align: unset !important;
    }

    .rest {
        display: inline-block;
        float: right;
        padding-top: 0.03rem;
    }

    .curtain {
        z-index: 2;
        height: 100%;
        width: 100%;
        background: #0f0f0f;
        opacity: 50%;
        position: fixed;
        top: 0;
        left: 0;
    }
    .add-special{
        z-index: 3;
    }
    .dropdown-menu-self {
        position: fixed;
        /* top: 20%; */
        height: 61% !important;
        /* left: 15% !important; */
        top: 50% !important;
        left: 50% !important;
        -ms-transform: translate(-50%, -50%) !important;
        transform: translate(-50%, -50%) !important;
        z-index: 1000;
        float: left;
        min-width: 160px;
        padding: 5px 0;
        margin: 2px 0 0;
        list-style: none;
        font-size: 14px;
        text-align: left;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
        background-clip: padding-box;
    }

    .specialhours input[type="checkbox"] {
        margin: 4px 0.2rem 0;
    }
    .special-action{
        margin-top: 0.2rem;
    }
    .special-list-item{
        color:#000000;
        margin:0.05rem 0 0.01rem;
        font-size:0.15rem;
        font-weight: 400;
    }
    .Profile-edit-body{
        margin-bottom: 45% !important;
    }
    .Profile-edit-back{
        bottom: 1.01rem !important;
    }
    .Profile-edit-save{
        bottom: 0.25rem !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Editprofile.vue